import { render, staticRenderFns } from "./Internships.vue?vue&type=template&id=4a38be4c&scoped=true"
import script from "./Internships.vue?vue&type=script&lang=js"
export * from "./Internships.vue?vue&type=script&lang=js"
import style0 from "./Internships.vue?vue&type=style&index=0&id=4a38be4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38be4c",
  null
  
)

export default component.exports